export enum ComponentHeight {
    stats = "50vh"
}



// WEBPACK FOOTER //
// ./src/app/models/enums/component-height.enum.ts